
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 3.15.2
 * Query Engine version: 461d6a05159055555eb7dfb337c9fb271cbd4d7e
 */
Prisma.prismaVersion = {
  client: "3.15.2",
  engine: "461d6a05159055555eb7dfb337c9fb271cbd4d7e"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = 'DbNull'
Prisma.JsonNull = 'JsonNull'
Prisma.AnyNull = 'AnyNull'

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.SettingsScalarFieldEnum = makeEnum({
  id: 'id',
  nameEn: 'nameEn',
  nameAr: 'nameAr',
  value: 'value',
  createdAt: 'createdAt'
});

exports.Prisma.AccountScalarFieldEnum = makeEnum({
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
});

exports.Prisma.SessionScalarFieldEnum = makeEnum({
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  nameAr: 'nameAr',
  emailVerified: 'emailVerified',
  email: 'email',
  image: 'image',
  mobileNumber: 'mobileNumber',
  gender: 'gender',
  twitter: 'twitter',
  linkedIn: 'linkedIn',
  balance: 'balance',
  marketerBalance: 'marketerBalance',
  scfhs: 'scfhs',
  scfhsExp: 'scfhsExp',
  nameOnCommercialRecord: 'nameOnCommercialRecord',
  commercialRecord: 'commercialRecord',
  logoUrl: 'logoUrl',
  cvId: 'cvId',
  inviterId: 'inviterId',
  specialtyId: 'specialtyId',
  roleId: 'roleId',
  professionId: 'professionId',
  cityId: 'cityId',
  stateId: 'stateId',
  countryId: 'countryId',
  nationalityId: 'nationalityId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  adminNotes: 'adminNotes',
  cv: 'cv',
  forgotCode: 'forgotCode',
  lastLogin: 'lastLogin',
  password: 'password',
  userEmailVerified: 'userEmailVerified',
  username: 'username',
  verifyEmailCode: 'verifyEmailCode',
  qualificationId: 'qualificationId',
  identityNo: 'identityNo',
  birthday: 'birthday',
  fcmToken: 'fcmToken'
});

exports.Prisma.VerificationTokenScalarFieldEnum = makeEnum({
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
});

exports.Prisma.QualificationScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.SpecialtyScalarFieldEnum = makeEnum({
  id: 'id',
  titleEn: 'titleEn',
  titleAr: 'titleAr',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  professionId: 'professionId'
});

exports.Prisma.RankScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.RoleScalarFieldEnum = makeEnum({
  id: 'id',
  titleAr: 'titleAr',
  titleEn: 'titleEn',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.CountryScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  nameAr: 'nameAr',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.StateScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  countryId: 'countryId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.CityScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  nameAr: 'nameAr',
  latitude: 'latitude',
  longitude: 'longitude',
  stateId: 'stateId',
  countryId: 'countryId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.ProfessionScalarFieldEnum = makeEnum({
  id: 'id',
  sortOrder: 'sortOrder',
  titleEn: 'titleEn',
  titleAr: 'titleAr',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  couponId: 'couponId'
});

exports.Prisma.MemberNeedsScalarFieldEnum = makeEnum({
  id: 'id',
  courseTitle: 'courseTitle',
  information: 'information',
  objectives: 'objectives',
  data: 'data',
  status: 'status',
  userId: 'userId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.MemberNeedSettingsScalarFieldEnum = makeEnum({
  id: 'id',
  titleAr: 'titleAr',
  titleEn: 'titleEn',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.BankAccountScalarFieldEnum = makeEnum({
  id: 'id',
  iban: 'iban',
  accountHolderName: 'accountHolderName',
  bankName: 'bankName',
  userId: 'userId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TransitionScalarFieldEnum = makeEnum({
  id: 'id',
  firstPartyOpeningBalance: 'firstPartyOpeningBalance',
  secondPartyOpeningBalance: 'secondPartyOpeningBalance',
  firstPartyClosingBalance: 'firstPartyClosingBalance',
  secondPartyClosingBalance: 'secondPartyClosingBalance',
  amount: 'amount',
  tax: 'tax',
  receiptUrl: 'receiptUrl',
  description: 'description',
  fullAmount: 'fullAmount',
  transitionTypeId: 'transitionTypeId',
  transitionStatusTypeId: 'transitionStatusTypeId',
  paymentWayId: 'paymentWayId',
  firstPartyUserId: 'firstPartyUserId',
  secondPartyUserId: 'secondPartyUserId',
  mediatorId: 'mediatorId',
  traineeEventId: 'traineeEventId',
  traineeEventGroupId: 'traineeEventGroupId',
  trainerEventId: 'trainerEventId',
  transitionPurposeId: 'transitionPurposeId',
  createdAt: 'createdAt',
  transitionId: 'transitionId',
  eventId: 'eventId',
  moyasarId: 'moyasarId',
  moyasarFee: 'moyasarFee',
  isHiddenFromUser: 'isHiddenFromUser'
});

exports.Prisma.TransitionPurposeScalarFieldEnum = makeEnum({
  id: 'id',
  titleAr: 'titleAr',
  titleEn: 'titleEn',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TransitionTypeScalarFieldEnum = makeEnum({
  id: 'id',
  titleEn: 'titleEn',
  titleAr: 'titleAr',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.PaymentWayScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.EventScalarFieldEnum = makeEnum({
  id: 'id',
  startDate: 'startDate',
  endDate: 'endDate',
  isTrainerCertificateAvailable: 'isTrainerCertificateAvailable',
  isTraineeCertificateAvailable: 'isTraineeCertificateAvailable',
  minAttendancePercentageToGetCertificate: 'minAttendancePercentageToGetCertificate',
  isAccredited: 'isAccredited',
  isAccreditedSHA: 'isAccreditedSHA',
  addedById: 'addedById',
  onsiteCapacity: 'onsiteCapacity',
  address: 'address',
  addressAr: 'addressAr',
  backgroundImagesUrls: 'backgroundImagesUrls',
  isSponsored: 'isSponsored',
  sponsorshipImagesUrls: 'sponsorshipImagesUrls',
  isContentProvidedByAcademy: 'isContentProvidedByAcademy',
  titleAr: 'titleAr',
  titleEn: 'titleEn',
  addressInstructions: 'addressInstructions',
  addressInstructionsAr: 'addressInstructionsAr',
  locationLongitude: 'locationLongitude',
  locationLatitude: 'locationLatitude',
  onlineCapacity: 'onlineCapacity',
  imageUrl: 'imageUrl',
  youtubeUrl: 'youtubeUrl',
  cmeHours: 'cmeHours',
  introductionAr: 'introductionAr',
  introductionEn: 'introductionEn',
  objectivesAr: 'objectivesAr',
  objectivesEn: 'objectivesEn',
  mainThemeAr: 'mainThemeAr',
  mainThemeEn: 'mainThemeEn',
  outcomesAr: 'outcomesAr',
  outcomesEn: 'outcomesEn',
  whyTargetedAudienceAr: 'whyTargetedAudienceAr',
  whyTargetedAudienceEn: 'whyTargetedAudienceEn',
  visibleOnArchive: 'visibleOnArchive',
  eventTypeId: 'eventTypeId',
  trainerCertificateTemplateId: 'trainerCertificateTemplateId',
  traineeCertificateTemplateId: 'traineeCertificateTemplateId',
  leaderTrainerId: 'leaderTrainerId',
  cityId: 'cityId',
  folderId: 'folderId',
  pricingPlanId: 'pricingPlanId',
  methodOfDeliveryId: 'methodOfDeliveryId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  invitersCanApprovePayments: 'invitersCanApprovePayments',
  cmeNumber: 'cmeNumber',
  isAllProfessionsTargeted: 'isAllProfessionsTargeted',
  isRegistraionClosed: 'isRegistraionClosed',
  numberOfVisits: 'numberOfVisits',
  packageId: 'packageId',
  shortDescriptionAr: 'shortDescriptionAr',
  shortDescriptionEn: 'shortDescriptionEn',
  zoomMode: 'zoomMode',
  discussionStatus: 'discussionStatus',
  meetingId: 'meetingId',
  zoomMeetingId: 'zoomMeetingId',
  timeTableStatus: 'timeTableStatus',
  descriptionAr: 'descriptionAr',
  descriptionEn: 'descriptionEn',
  keywordsAr: 'keywordsAr',
  keywordsEn: 'keywordsEn',
  defaultLanguage: 'defaultLanguage',
  hideVideoProgress: 'hideVideoProgress'
});

exports.Prisma.MethodOfDeliveryScalarFieldEnum = makeEnum({
  id: 'id',
  titleAr: 'titleAr',
  titleEn: 'titleEn',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.EventTypeScalarFieldEnum = makeEnum({
  id: 'id',
  titleEn: 'titleEn',
  titleAr: 'titleAr',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TemplateScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  subject: 'subject',
  data: 'data',
  purpose: 'purpose',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  zohotemplateid: 'zohotemplateid',
  key_alias: 'key_alias'
});

exports.Prisma.LanguageScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.EventFolderScalarFieldEnum = makeEnum({
  id: 'id',
  titleEn: 'titleEn',
  titleAr: 'titleAr',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.PricingPlanScalarFieldEnum = makeEnum({
  id: 'id',
  hasLateRegistration: 'hasLateRegistration',
  lateRegistrationStartDate: 'lateRegistrationStartDate',
  hasGroupDiscount: 'hasGroupDiscount',
  groupDiscountPrice: 'groupDiscountPrice',
  hasGroupDiscountEndDate: 'hasGroupDiscountEndDate',
  groupDiscountEndDate: 'groupDiscountEndDate',
  groupDiscountMinNumberOfRegistrants: 'groupDiscountMinNumberOfRegistrants',
  hasWorkshop: 'hasWorkshop',
  workshopPrice: 'workshopPrice',
  workshopLateRegistrationPrice: 'workshopLateRegistrationPrice',
  workshopGroupDiscountPrice: 'workshopGroupDiscountPrice',
  pricingPlanTypeId: 'pricingPlanTypeId',
  freePlanCertificateCmeIsPaid: 'freePlanCertificateCmeIsPaid',
  freePlanCertificateCmePrice: 'freePlanCertificateCmePrice',
  paidPlanPrice: 'paidPlanPrice',
  paidPlanOfflinePrice: 'paidPlanOfflinePrice',
  paidPlanOnsitePrice: 'paidPlanOnsitePrice',
  paidPlanLateRegistrationPrice: 'paidPlanLateRegistrationPrice',
  basedOnSpecialtyPlanOtherSpecialtiesPrice: 'basedOnSpecialtyPlanOtherSpecialtiesPrice',
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice: 'basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice',
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice: 'basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  cardFee: 'cardFee',
  freePlanCertificateStatus: 'freePlanCertificateStatus',
  hasMultiPartDiscount: 'hasMultiPartDiscount',
  multiPartDiscountPrice: 'multiPartDiscountPrice',
  paymentType: 'paymentType',
  hasDiscount: 'hasDiscount',
  hasDiscountEndDate: 'hasDiscountEndDate',
  discountEndDate: 'discountEndDate',
  discountPercentage: 'discountPercentage'
});

exports.Prisma.PricingPlanTypeScalarFieldEnum = makeEnum({
  id: 'id',
  titleAr: 'titleAr',
  titleEn: 'titleEn',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.EventPartScalarFieldEnum = makeEnum({
  id: 'id',
  outlineAr: 'outlineAr',
  outlineEn: 'outlineEn',
  eventId: 'eventId',
  pricingPlanId: 'pricingPlanId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.EventDayScalarFieldEnum = makeEnum({
  id: 'id',
  date: 'date',
  startTime: 'startTime',
  endTime: 'endTime',
  cmeHours: 'cmeHours',
  outlineAr: 'outlineAr',
  outlineEn: 'outlineEn',
  hasWorkshop: 'hasWorkshop',
  eventPartId: 'eventPartId',
  eventId: 'eventId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  methodOfDeliveryId: 'methodOfDeliveryId',
  attendanceHours: 'attendanceHours',
  zoomDuration: 'zoomDuration',
  zoomMeetingUUID: 'zoomMeetingUUID',
  hidden: 'hidden',
  brotherId: 'brotherId'
});

exports.Prisma.ZoomMeetingScalarFieldEnum = makeEnum({
  id: 'id',
  meetingId: 'meetingId',
  joinUrl: 'joinUrl',
  type: 'type',
  isProcessed: 'isProcessed',
  startDateTime: 'startDateTime',
  endDateTime: 'endDateTime',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  eventDayId: 'eventDayId',
  duration: 'duration',
  password: 'password',
  startUrl: 'startUrl',
  registrationUrl: 'registrationUrl',
  isStarted: 'isStarted'
});

exports.Prisma.PricingPlanSpecialtyPriceScalarFieldEnum = makeEnum({
  id: 'id',
  price: 'price',
  priceOnsite: 'priceOnsite',
  LateRegistrationPrice: 'LateRegistrationPrice',
  pricingPlanId: 'pricingPlanId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TraineeEventScalarFieldEnum = makeEnum({
  id: 'id',
  price: 'price',
  tax: 'tax',
  totalToPay: 'totalToPay',
  isLateRegistrant: 'isLateRegistrant',
  isWorkshopRegistrant: 'isWorkshopRegistrant',
  isGroupRegistrant: 'isGroupRegistrant',
  workshopPrice: 'workshopPrice',
  isIndividualPay: 'isIndividualPay',
  certificatePrice: 'certificatePrice',
  hasBookedAllParts: 'hasBookedAllParts',
  traineeId: 'traineeId',
  inviterId: 'inviterId',
  eventId: 'eventId',
  eventDayId: 'eventDayId',
  bookingStatusId: 'bookingStatusId',
  groupId: 'groupId',
  howHeardAboutEventId: 'howHeardAboutEventId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  methodOfDeliveryId: 'methodOfDeliveryId',
  couponId: 'couponId',
  couponeDiscount: 'couponeDiscount',
  isFirstRegistration: 'isFirstRegistration',
  isPackageBooking: 'isPackageBooking',
  walletBalance: 'walletBalance',
  registrantToken: 'registrantToken',
  registrantId: 'registrantId',
  emailState: 'emailState',
  isGuest: 'isGuest',
  isCertificateIssued: 'isCertificateIssued',
  paymentNetworkId: 'paymentNetworkId',
  ePaymentMethodId: 'ePaymentMethodId'
});

exports.Prisma.CertificateScalarFieldEnum = makeEnum({
  id: 'id',
  traineeEventId: 'traineeEventId',
  traineeId: 'traineeId',
  trainerEventId: 'trainerEventId',
  eventId: 'eventId',
  metaData: 'metaData',
  templateId: 'templateId',
  isEligible: 'isEligible',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.HowHeardAboutEventScalarFieldEnum = makeEnum({
  id: 'id',
  titleEn: 'titleEn',
  titleAr: 'titleAr',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.BookingStatusScalarFieldEnum = makeEnum({
  id: 'id',
  titleEn: 'titleEn',
  titleAr: 'titleAr',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TraineeEventGroupScalarFieldEnum = makeEnum({
  id: 'id',
  areLateRegistrants: 'areLateRegistrants',
  groupTotalToPay: 'groupTotalToPay',
  groupPrice: 'groupPrice',
  groupTax: 'groupTax',
  areWorkshopRegistrants: 'areWorkshopRegistrants',
  groupWorkshopPrice: 'groupWorkshopPrice',
  groupCertificatePrice: 'groupCertificatePrice',
  isGroupPay: 'isGroupPay',
  eventId: 'eventId',
  leaderId: 'leaderId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  couponId: 'couponId',
  couponeDiscount: 'couponeDiscount',
  groupWalletBalance: 'groupWalletBalance'
});

exports.Prisma.TraineeEventPartScalarFieldEnum = makeEnum({
  id: 'id',
  partTotalPrice: 'partTotalPrice',
  traineeEventId: 'traineeEventId',
  eventPartId: 'eventPartId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TraineeEventDayAttendanceScalarFieldEnum = makeEnum({
  id: 'id',
  joinTime: 'joinTime',
  leaveTime: 'leaveTime',
  traineeEventId: 'traineeEventId',
  eventDayId: 'eventDayId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  isZoomMeeting: 'isZoomMeeting',
  participantId: 'participantId',
  participantName: 'participantName',
  duration: 'duration'
});

exports.Prisma.TraineeEventZoomRegistrationScalarFieldEnum = makeEnum({
  id: 'id',
  traineeEventId: 'traineeEventId',
  joinUrl: 'joinUrl',
  zoomMeetingId: 'zoomMeetingId',
  meetingId: 'meetingId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  registrantId: 'registrantId'
});

exports.Prisma.TrainerEventScalarFieldEnum = makeEnum({
  id: 'id',
  youtubeUrl: 'youtubeUrl',
  introductionEn: 'introductionEn',
  introductionAr: 'introductionAr',
  objectivesEn: 'objectivesEn',
  objectivesAr: 'objectivesAr',
  mainThemeEn: 'mainThemeEn',
  mainThemeAr: 'mainThemeAr',
  outcomesEn: 'outcomesEn',
  outcomesAr: 'outcomesAr',
  whyTargetedAudienceAr: 'whyTargetedAudienceAr',
  whyTargetedAudienceEn: 'whyTargetedAudienceEn',
  contentIsAdded: 'contentIsAdded',
  toTransferAmount: 'toTransferAmount',
  toTransferType: 'toTransferType',
  trainerId: 'trainerId',
  eventId: 'eventId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  isAllProfessionsTargeted: 'isAllProfessionsTargeted',
  joinUrl: 'joinUrl',
  registrantId: 'registrantId',
  emailState: 'emailState'
});

exports.Prisma.TrainerEventStudyMaterialScalarFieldEnum = makeEnum({
  id: 'id',
  url: 'url',
  title: 'title',
  trainerEventId: 'trainerEventId',
  eventId: 'eventId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  media: 'media',
  order: 'order',
  trainerEventStudyMaterialGroupId: 'trainerEventStudyMaterialGroupId',
  quizId: 'quizId'
});

exports.Prisma.TrainerEventStudyMaterialGroupScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  order: 'order',
  eventId: 'eventId'
});

exports.Prisma.TraineeEventStudyMaterialAttendanceScalarFieldEnum = makeEnum({
  id: 'id',
  traineeEventId: 'traineeEventId',
  progressPercentage: 'progressPercentage',
  trainerEventStudyMaterialId: 'trainerEventStudyMaterialId'
});

exports.Prisma.TrainerEventDayLessonScalarFieldEnum = makeEnum({
  id: 'id',
  startTime: 'startTime',
  endTime: 'endTime',
  outlineAr: 'outlineAr',
  outlineEn: 'outlineEn',
  trainerEventId: 'trainerEventId',
  eventDayId: 'eventDayId',
  methodOfTeachingTypeId: 'methodOfTeachingTypeId',
  trainerEventDayLessonTypeId: 'trainerEventDayLessonTypeId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.MethodOfTeachingTypeScalarFieldEnum = makeEnum({
  id: 'id',
  titleAr: 'titleAr',
  titleEn: 'titleEn',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TrainerEventDayLessonTypeScalarFieldEnum = makeEnum({
  id: 'id',
  titleAr: 'titleAr',
  titleEn: 'titleEn',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TrainerEventDayTimeSlotScalarFieldEnum = makeEnum({
  id: 'id',
  startTime: 'startTime',
  endTime: 'endTime',
  addedById: 'addedById',
  trainerEventId: 'trainerEventId',
  eventDayId: 'eventDayId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TraineeTrainerReviewScalarFieldEnum = makeEnum({
  id: 'id',
  reviewOfFive: 'reviewOfFive',
  why: 'why',
  traineeEventId: 'traineeEventId',
  trainerEventId: 'trainerEventId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TraineeTrainerReviewChoiceScalarFieldEnum = makeEnum({
  id: 'id',
  titleEn: 'titleEn',
  titleAr: 'titleAr',
  isGood: 'isGood',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.BecomeTrainerApplicationScalarFieldEnum = makeEnum({
  id: 'id',
  state: 'state',
  applicantId: 'applicantId',
  cvId: 'cvId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  rejectedCount: 'rejectedCount'
});

exports.Prisma.CouponScalarFieldEnum = makeEnum({
  id: 'id',
  couponType: 'couponType',
  fixedAmountDiscount: 'fixedAmountDiscount',
  percentageDiscount: 'percentageDiscount',
  percentageMaxAmount: 'percentageMaxAmount',
  expiryDate: 'expiryDate',
  isForAllSpecialties: 'isForAllSpecialties',
  isForAllEvents: 'isForAllEvents',
  inviterId: 'inviterId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  code: 'code',
  marketerProfitType: 'marketerProfitType',
  percentageMarketerProfit: 'percentageMarketerProfit',
  fixedAmountMarketerProfit: 'fixedAmountMarketerProfit'
});

exports.Prisma.TransitionStatusTypeScalarFieldEnum = makeEnum({
  id: 'id',
  titleEn: 'titleEn',
  titleAr: 'titleAr',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TraineeEventReviewScalarFieldEnum = makeEnum({
  id: 'id',
  reviewOfFive: 'reviewOfFive',
  why: 'why',
  traineeEventId: 'traineeEventId',
  eventId: 'eventId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.TraineeEventReviewChoiceScalarFieldEnum = makeEnum({
  id: 'id',
  titleEn: 'titleEn',
  titleAr: 'titleAr',
  isGood: 'isGood',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.CvScalarFieldEnum = makeEnum({
  id: 'id',
  qualificationId: 'qualificationId',
  rankId: 'rankId'
});

exports.Prisma.TrainingExperienceScalarFieldEnum = makeEnum({
  id: 'id',
  eventName: 'eventName',
  executingAgency: 'executingAgency',
  cvId: 'cvId'
});

exports.Prisma.EducationScalarFieldEnum = makeEnum({
  id: 'id',
  university: 'university',
  graduationYear: 'graduationYear',
  cvId: 'cvId',
  professionId: 'professionId',
  specialtyId: 'specialtyId',
  qualificationId: 'qualificationId'
});

exports.Prisma.ProfessionalSkillsScalarFieldEnum = makeEnum({
  id: 'id',
  yearsOfExperience: 'yearsOfExperience',
  placeOfWork: 'placeOfWork',
  natureOfWork: 'natureOfWork',
  type: 'type',
  cvId: 'cvId',
  academicRankId: 'academicRankId'
});

exports.Prisma.AcademicRankScalarFieldEnum = makeEnum({
  id: 'id',
  titleEn: 'titleEn',
  titleAr: 'titleAr'
});

exports.Prisma.ScientificResearchScalarFieldEnum = makeEnum({
  id: 'id',
  description: 'description',
  type: 'type',
  role: 'role',
  cvId: 'cvId'
});

exports.Prisma.AutomatedEmailsScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  sendTo: 'sendTo',
  time: 'time',
  days: 'days',
  forRegistrans: 'forRegistrans',
  whenEventHasClasses: 'whenEventHasClasses',
  templateId: 'templateId',
  notificationId: 'notificationId',
  message: 'message'
});

exports.Prisma.NotificationScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  message: 'message',
  link: 'link',
  read: 'read',
  userId: 'userId',
  createdAt: 'createdAt',
  metadata: 'metadata'
});

exports.Prisma.DiscussionScalarFieldEnum = makeEnum({
  id: 'id',
  comment: 'comment',
  userId: 'userId',
  createdAt: 'createdAt',
  eventId: 'eventId',
  parentId: 'parentId'
});

exports.Prisma.QuizScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  eventId: 'eventId'
});

exports.Prisma.QuizQuestionScalarFieldEnum = makeEnum({
  id: 'id',
  questionAr: 'questionAr',
  questionEn: 'questionEn',
  questionType: 'questionType',
  questionOrder: 'questionOrder',
  quizId: 'quizId',
  createdAt: 'createdAt',
  rightAnswer: 'rightAnswer'
});

exports.Prisma.QuizQuestionAnswerScalarFieldEnum = makeEnum({
  id: 'id',
  answerAr: 'answerAr',
  answerEn: 'answerEn',
  createdAt: 'createdAt',
  quizQuestionId: 'quizQuestionId'
});

exports.Prisma.QuizResultScalarFieldEnum = makeEnum({
  id: 'id',
  quizId: 'quizId',
  quizQuestionId: 'quizQuestionId',
  userId: 'userId',
  eventId: 'eventId',
  quizQuestionAnswerId: 'quizQuestionAnswerId'
});

exports.Prisma.EPaymentMethodScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  createdAt: 'createdAt'
});

exports.Prisma.PaymentNetworkScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  createdAt: 'createdAt'
});

exports.Prisma.ZohoEmailScalarFieldEnum = makeEnum({
  id: 'id',
  request_id: 'request_id',
  subject: 'subject',
  userId: 'userId',
  createdAt: 'createdAt',
  eventId: 'eventId',
  sent: 'sent',
  clicked: 'clicked',
  opened: 'opened',
  softBounce: 'softBounce',
  hardBounce: 'hardBounce',
  htmlData: 'htmlData',
  templateId: 'templateId',
  traineeEventId: 'traineeEventId',
  trainerEventId: 'trainerEventId'
});

exports.Prisma.EventMediaTrackingScalarFieldEnum = makeEnum({
  id: 'id',
  twitter: 'twitter',
  facebook: 'facebook',
  instagram: 'instagram',
  email: 'email',
  linkedin: 'linkedin',
  whatsApp: 'whatsApp',
  google: 'google',
  telegram: 'telegram',
  ertiqaa: 'ertiqaa',
  anat: 'anat',
  friend: 'friend',
  eventId: 'eventId',
  traineeId: 'traineeId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.InviterCouponProfitScalarFieldEnum = makeEnum({
  id: 'id',
  eventId: 'eventId',
  inviterId: 'inviterId',
  couponId: 'couponId',
  userId: 'userId',
  traineeEventId: 'traineeEventId',
  profit: 'profit',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.EventIdentityCardTemplateScalarFieldEnum = makeEnum({
  id: 'id',
  eventId: 'eventId',
  templateData: 'templateData'
});

exports.Prisma.ContactUsDataScalarFieldEnum = makeEnum({
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phoneNumber: 'phoneNumber',
  subject: 'subject',
  message: 'message',
  reason: 'reason',
  isRead: 'isRead',
  attachment: 'attachment'
});

exports.Prisma.HiddenEventsScalarFieldEnum = makeEnum({
  id: 'id',
  eventId: 'eventId'
});

exports.Prisma.BlogsScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  titleAr: 'titleAr',
  description: 'description',
  descriptionAr: 'descriptionAr',
  content: 'content',
  contentAr: 'contentAr',
  authorId: 'authorId',
  eventId: 'eventId',
  socialMedia: 'socialMedia',
  image: 'image',
  thumbnailImage: 'thumbnailImage',
  createdAt: 'createdAt'
});

exports.Prisma.InfinityMomentsContentPageScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  description: 'description',
  lastUpdated: 'lastUpdated'
});

exports.Prisma.InfinityMomentsContentPageSectionsScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  pageId: 'pageId',
  order: 'order',
  layout: 'layout'
});

exports.Prisma.InfinityMomentsContentPageContentBlockScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  content: 'content',
  sectionId: 'sectionId',
  order: 'order'
});

exports.Prisma.SubscriptionScalarFieldEnum = makeEnum({
  id: 'id',
  amount: 'amount',
  startDate: 'startDate',
  endDate: 'endDate',
  receiptUrl: 'receiptUrl',
  description: 'description',
  customSubscriptionTypeName: 'customSubscriptionTypeName',
  subscriptionTypeId: 'subscriptionTypeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.SubscriptionTypeScalarFieldEnum = makeEnum({
  id: 'id',
  nameEn: 'nameEn',
  nameAr: 'nameAr',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull'
});

exports.Prisma.JsonNullValueInput = makeEnum({
  JsonNull: 'JsonNull'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull',
  AnyNull: 'AnyNull'
});
exports.Gender = makeEnum({
  male: 'male',
  female: 'female'
});

exports.MemberNeedsStatus = makeEnum({
  pending: 'pending',
  approved: 'approved',
  declined: 'declined',
  important: 'important'
});

exports.LanguageEnum = makeEnum({
  en: 'en',
  ar: 'ar'
});

exports.TemplatePurpose = makeEnum({
  certificate: 'certificate',
  email: 'email',
  notification: 'notification',
  page: 'page',
  others: 'others'
});

exports.PaymentType = makeEnum({
  electronic: 'electronic',
  external: 'external'
});

exports.ToTransferType = makeEnum({
  percentage: 'percentage',
  fixed: 'fixed'
});

exports.ApplicationState = makeEnum({
  pending: 'pending',
  approved: 'approved',
  declined: 'declined'
});

exports.CouponType = makeEnum({
  fixed: 'fixed',
  percentage: 'percentage'
});

exports.MarketerProfitType = makeEnum({
  fixed: 'fixed',
  percentage: 'percentage'
});

exports.ProfessionalSkillsType = makeEnum({
  academic: 'academic',
  practicalExperiance: 'practicalExperiance'
});

exports.ScientificResearchType = makeEnum({
  conferences: 'conferences',
  journals: 'journals'
});

exports.ScientificResearchRole = makeEnum({
  lead: 'lead',
  assistant: 'assistant'
});

exports.DynamicEmailSendTo = makeEnum({
  trainees: 'trainees',
  trainers: 'trainers',
  marketer: 'marketer',
  organizer: 'organizer',
  all: 'all'
});

exports.DynamicEmailTime = makeEnum({
  afterEvent: 'afterEvent',
  afterPayment: 'afterPayment',
  afterPublishingEvent: 'afterPublishingEvent',
  beforeEvent: 'beforeEvent',
  beforeLateRegistration: 'beforeLateRegistration',
  afterCertificateIssued: 'afterCertificateIssued',
  emergancyAfterEventCancellation: 'emergancyAfterEventCancellation',
  emergancyAfterChangeOfTrainers: 'emergancyAfterChangeOfTrainers',
  emergancyAfterChangeOfDateTime: 'emergancyAfterChangeOfDateTime',
  emergancyAfterChangeOfLocation: 'emergancyAfterChangeOfLocation',
  remindMe: 'remindMe'
});

exports.DynamicEmailForRegistrans = makeEnum({
  paid: 'paid',
  unpaid: 'unpaid',
  toBeReminded: 'toBeReminded',
  havingTheSameSpecialty: 'havingTheSameSpecialty',
  all: 'all',
  justRegister: 'justRegister',
  certificateIsPaid: 'certificateIsPaid',
  certificateAndCMEIsPaid: 'certificateAndCMEIsPaid',
  certificateAndCMEIsFree: 'certificateAndCMEIsFree'
});

exports.DynamicwhenEventHasClasses = makeEnum({
  online: 'online',
  offline: 'offline',
  all: 'all'
});

exports.Prisma.ModelName = makeEnum({
  Settings: 'Settings',
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  VerificationToken: 'VerificationToken',
  Qualification: 'Qualification',
  Specialty: 'Specialty',
  Rank: 'Rank',
  Role: 'Role',
  Country: 'Country',
  State: 'State',
  City: 'City',
  Profession: 'Profession',
  MemberNeeds: 'MemberNeeds',
  MemberNeedSettings: 'MemberNeedSettings',
  BankAccount: 'BankAccount',
  Transition: 'Transition',
  TransitionPurpose: 'TransitionPurpose',
  TransitionType: 'TransitionType',
  PaymentWay: 'PaymentWay',
  Event: 'Event',
  MethodOfDelivery: 'MethodOfDelivery',
  EventType: 'EventType',
  Template: 'Template',
  Language: 'Language',
  EventFolder: 'EventFolder',
  PricingPlan: 'PricingPlan',
  PricingPlanType: 'PricingPlanType',
  EventPart: 'EventPart',
  EventDay: 'EventDay',
  ZoomMeeting: 'ZoomMeeting',
  PricingPlanSpecialtyPrice: 'PricingPlanSpecialtyPrice',
  TraineeEvent: 'TraineeEvent',
  Certificate: 'Certificate',
  HowHeardAboutEvent: 'HowHeardAboutEvent',
  BookingStatus: 'BookingStatus',
  TraineeEventGroup: 'TraineeEventGroup',
  TraineeEventPart: 'TraineeEventPart',
  TraineeEventDayAttendance: 'TraineeEventDayAttendance',
  TraineeEventZoomRegistration: 'TraineeEventZoomRegistration',
  TrainerEvent: 'TrainerEvent',
  TrainerEventStudyMaterial: 'TrainerEventStudyMaterial',
  TrainerEventStudyMaterialGroup: 'TrainerEventStudyMaterialGroup',
  TraineeEventStudyMaterialAttendance: 'TraineeEventStudyMaterialAttendance',
  TrainerEventDayLesson: 'TrainerEventDayLesson',
  MethodOfTeachingType: 'MethodOfTeachingType',
  TrainerEventDayLessonType: 'TrainerEventDayLessonType',
  TrainerEventDayTimeSlot: 'TrainerEventDayTimeSlot',
  TraineeTrainerReview: 'TraineeTrainerReview',
  TraineeTrainerReviewChoice: 'TraineeTrainerReviewChoice',
  BecomeTrainerApplication: 'BecomeTrainerApplication',
  Coupon: 'Coupon',
  TransitionStatusType: 'TransitionStatusType',
  TraineeEventReview: 'TraineeEventReview',
  TraineeEventReviewChoice: 'TraineeEventReviewChoice',
  Cv: 'Cv',
  TrainingExperience: 'TrainingExperience',
  Education: 'Education',
  ProfessionalSkills: 'ProfessionalSkills',
  AcademicRank: 'AcademicRank',
  ScientificResearch: 'ScientificResearch',
  AutomatedEmails: 'AutomatedEmails',
  Notification: 'Notification',
  Discussion: 'Discussion',
  Quiz: 'Quiz',
  QuizQuestion: 'QuizQuestion',
  QuizQuestionAnswer: 'QuizQuestionAnswer',
  QuizResult: 'QuizResult',
  EPaymentMethod: 'EPaymentMethod',
  PaymentNetwork: 'PaymentNetwork',
  ZohoEmail: 'ZohoEmail',
  EventMediaTracking: 'EventMediaTracking',
  InviterCouponProfit: 'InviterCouponProfit',
  EventIdentityCardTemplate: 'EventIdentityCardTemplate',
  ContactUsData: 'ContactUsData',
  HiddenEvents: 'HiddenEvents',
  Blogs: 'Blogs',
  InfinityMomentsContentPage: 'InfinityMomentsContentPage',
  InfinityMomentsContentPageSections: 'InfinityMomentsContentPageSections',
  InfinityMomentsContentPageContentBlock: 'InfinityMomentsContentPageContentBlock',
  Subscription: 'Subscription',
  SubscriptionType: 'SubscriptionType'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
